export default function hideBreadcrumbs () {
    if(window.matchMedia("(min-width: 660px)").matches) return false

    const bcItems = document.querySelectorAll('.bread-crumbs li')

    if (bcItems) {
        bcItems.forEach(item => {
            if(bcItems.length > 3) {

            }
            if(item.classList.contains('bread-crumbs__this')) {
                item.remove()
            }
        })
    }

}


// WEBPACK FOOTER //
// ./src/js/hideBreadcrumbs.js